import { Component, OnInit } from '@angular/core';
import { FormGroup,Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';

import { MapDataService } from '../../dashboard/components/services/map-data.service';
import { UserSessionComponent } from 'src/app/dashboard/user-session/user-session.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    email: new FormControl('',Validators.required),
    password: new FormControl('', Validators.required),
  });
  coordinates ={
    latitude : 0.0000,
    longitude : 0.0000
  }
  passwordHide = true;
  errorMessage = '';
  isLocal = false;
  ssValues: any;
  current = 0;
  
  constructor(
    private router:Router,
    private mapService:MapDataService,
    private userService:UserService,
    private authService:AuthService,
    private userSessionDialog : MatDialog) {
     // this.getCurrentLocation();
     }

  ngOnInit(): void {
    if(this.authService.isLoggedIn){
      this.router.navigate(['/dashboard']);
    } else {
      const route = this.router["location"]["_platformLocation"]["location"].host;
      this.isLocal = (route == "localhost:4200")? true: false;
    }
  }
  
  onSubmit() :void {
    const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
    var currentCount;
    if(storedUser == null) {
      currentCount = 0
    } else {
      currentCount = storedUser.current
    }
    

    if(this.loginForm.valid){
      this.userService.login(this.loginForm.value).subscribe(
        (res:any) => {
          if(res.responseStatus === 'Success'){
            this.errorMessage = '';
            this.current = currentCount + 1;
            this.authService.login(res.responseData.userId,res.responseToken.token, res.responseToken.maxSession, res.responseToken.sessionValsLength)
            //this.ssValues = res.responseToken.sessionVals;
            this.ssValues = res.responseToken;
            //if user session exists then show up the session management dialog
           if(res.responseToken.sessionVals.result.length > 0) {
            this.userSessionDialog.open(UserSessionComponent, {
              width: '50rem',
              height: '30rem',
              data: this.ssValues,
              disableClose :false,
            });
          } else {
            this.router.navigate(['/dashboard']);
          }            
          } else {
            this.errorMessage = res.responseMessage;
            this.authService.logout();
          }
        },
        err => {
          this.errorMessage = JSON.stringify(err);
          console.log('Login Failed',err);
        }
      )
     
    }
  }
  /**
   * TODO - Implement Forgot Password
   */
  forgotPassword():void {
    console.log('This is forgot password');
  }
  navigateToSignup() {
    this.router.navigate(['/user/sign-up']);
  }
  getCurrentLocation() {
    this.mapService.getInitialMapCoordinates().subscribe(
      (res:any) => {
        const {latitude, longitude} = res;
        this.coordinates =  {latitude, longitude};
      },
      err => console.log(err)
    )
  }
  goToCDN(): void {
    window.location.href = "https://cdn.umlaut.com";
  }
}
